/**
 * Breakpoints designated by most common device usage
 * https://www.figma.com/file/w3nEyANoniTZdjz8kCUaDS/Bricks-Design-System?node-id=6881%3A17688&t=4QS53fgl4nBJp4hQ-0
 * Extra small: 0 - 374px
 * Small: 375 - 767px
 * Medium: 768 - 1200px
 * Large: 1201 - 1399px
 * Extra large: 1400px and up
 */
export const BREAKPOINTS = {
  SM: 375,
  MD: 768,
  LG: 1201,
  XL: 1400,
};

// note order is important!
// earlier defined = less important
export const media = {
  smallerThanXL: { maxWidth: BREAKPOINTS.XL - 1 },
  smallerThanLG: { maxWidth: BREAKPOINTS.LG - 1 },
  smallerThanMD: { maxWidth: BREAKPOINTS.MD - 1 },
  smallerThanSM: { maxWidth: BREAKPOINTS.SM - 1 },
  largerThanXS: { minWidth: BREAKPOINTS.SM },
  largerThanSM: { minWidth: BREAKPOINTS.MD },
  largerThanMD: { minWidth: BREAKPOINTS.LG },
  largerThanLG: { minWidth: BREAKPOINTS.XL },

  // use to target devices that do not support hover
  hoverNone: { hover: 'none' },
} as const;
